import { useContext, useCallback } from "react";
import { LanguageContext } from "../context/LanguageProvider";
import { useMsal } from "@azure/msal-react";
import { useAuthenticatedApiFetch } from "../hooks/useAuthenticatedApiFetch";
import { usePayableAmount } from "../hooks/usePayableAmount";
import { formatAmount } from "../utils/formatUtils";
import { useAppNavigation } from "../hooks/useAppNavigation";

const TotalPremium = ({ product, productId, client, premiums }) => {
  const { t, language } = useContext(LanguageContext);
  const { instance } = useMsal();
  const authenticatedApiFetch = useAuthenticatedApiFetch(instance);
  const { goToError } = useAppNavigation();

  // refreshKey toggles when premiums change -> used as key on child to force remount
  const refreshKey = Array.isArray(premiums)
    ? premiums.join("|")
    : String(premiums ?? "");

  const handleError = useCallback(() => {
    goToError({
      title: t?.("error") || "Error",
      message: t?.("unable_to_fetch_amount") || "Unable to fetch payable amount.",
    });
  }, [goToError, t]);

  return (
    <div className="total-premium">      
      <PayableAmountSection
        key={refreshKey}
        t={t}
        language={language}
        authenticatedApiFetch={authenticatedApiFetch}
        product={product}
        productId={productId}
        client={client}
        onError={handleError}
      />
    </div>
  );
};

/* Child component to re-trigger the hook's effects */
function PayableAmountSection({
  t,
  language,
  authenticatedApiFetch,
  product,
  productId,
  client,
  onError,
}) {
  const payableAmount = usePayableAmount(
    authenticatedApiFetch,
    product,
    productId,
    client,
    onError,
    t?.("error") || "Error",
    t?.("unable_to_fetch_amount") || "Unable to fetch payable amount."
  );

  if (payableAmount === null) {
    return (
      <div className="total-amount-results">
        <div className="loading-next">
          <div className="loading" />
        </div>
      </div>
    );
  }

  return (
    <>
      <div>{t("total_premium")}:</div>
      <div>{formatAmount(payableAmount, language)}</div>
    </>
  );
}

export default TotalPremium;
